/**
 * author: Patrick Vyn Badiang
 */
import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

function EventsList() {
    const [forms, setForms] = useState([]);
    const [selectedFormId, setSelectedFormId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [selectedFormName, setSelectedFormDate] = useState(''); // Added to store the name
    const [editFormData, setEditFormData] = useState({  event_url: '', name: '', date: '', description: '' }); // Use lowercase for state fields

    const [isAdding, setIsAdding] = useState(false); // State for adding new forms
    const [newFormData, setNewFormData] = useState({ event_url: '', name: '', date: '', description: '' }); // State for new form data

    // Fetch forms on component load
    useEffect(() => {
        fetch('https://9v3dtgzcma.execute-api.us-east-1.amazonaws.com/ascend-events')
        .then((response) => response.json())
        .then((data) => setForms(data))
        .catch((error) => console.error(error));
    }, []);

    // Handle adding form submission
    const handleAddSubmit = (e) => {
        e.preventDefault();
        fetch('https://9v3dtgzcma.execute-api.us-east-1.amazonaws.com/ascend-events', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event_url: newFormData.event_url, name: newFormData.name, date: newFormData.date, description: newFormData.description}),
        })
        .then((response) => response.json())
        .then(() => {
            // Fetch the updated list of forms from the backend
            return fetch('https://9v3dtgzcma.execute-api.us-east-1.amazonaws.com/ascend-events');
        })
        .then((response) => response.json())
        .then((data) => {
            setForms(data); // Update the state with the new list of forms
            setIsAdding(false); // Close the modal
            setNewFormData({ event_url: '', name: '', date: '', description: '' }); // Clear the form inputs
            alert('Event added successfully!');
        })
        .catch((error) => console.error(error));
    };

    // Handle edit button click
    const handleEdit = () => {
        if (!selectedFormId) {
        alert('Please select a form to edit.');
        return;
        }

        const selectedForm = forms.find((form) => form.id === selectedFormId);
        setEditFormData(selectedForm);
        setIsEditing(true);
    };

    // Handle editing form submission
    // Edit form submission
    const handleEditSubmit = (e) => {
    e.preventDefault();
    // console.log('Sending edit data:', editFormData);

    fetch(`https://9v3dtgzcma.execute-api.us-east-1.amazonaws.com/ascend-events/${selectedFormId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        originalName: selectedFormName, 
        event_url: editFormData.event_url, 
        name: editFormData.name, 
        date: editFormData.date, 
        description: editFormData.description }), // Correct field names
    })
      .then((response) => response.json())
      .then(() => {
        // Fetch the updated list of forms from the backend
        return fetch('https://9v3dtgzcma.execute-api.us-east-1.amazonaws.com/ascend-events');
      })
      .then((response) => response.json())
      .then((data) => {
        setForms(data); // Update the state with the new list of forms
        setIsEditing(false); // Close the modal
        setSelectedFormDate(editFormData.date); // Update the selected form name
        setNewFormData({ event_url: '', name: '', date: '', description: '' }); // Clear the form inputs
        alert('Form updated successfully!');
      })
      
      .catch((error) => console.error(error));
    };

    // Handle selecting an event
    const handleSelect = (id) => {
        setSelectedFormId(id === selectedFormId ? null : id); // Deselect if clicked again
        const selectedForm = forms.find((form) => form.id === id);
        setSelectedFormDate(selectedForm ? selectedForm.date : ''); // Store the name when selected
    };

    // Handle delete button click
  const handleDelete = () => {
    if (!selectedFormId) {
      alert('Please select a form to delete.');
      return;
    }

    // Use the selectedFormName in the delete request
    fetch(`https://9v3dtgzcma.execute-api.us-east-1.amazonaws.com/ascend-events/${selectedFormId}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ date: selectedFormName }), // Use the stored name for deletion
    })
      .then((response) => response.json())
      .then(() => {
        setForms(forms.filter((form) => form.id !== selectedFormId)); // Remove from state
        setSelectedFormId(null);
        setSelectedFormDate(''); // Clear the selected form name
        alert('Form deleted successfully!');
      })
      .catch((error) => console.error(error));
  };

    

    

    return (
        <div>
        <Typography variant="h2" color="primary">All Event</Typography>
        <ul style={{ listStyle: 'none', padding: 0 }}>
            {forms.map((form) => (
            <li
                key={form.id}
                style={{
                padding: '10px',
                margin: '5px 0',
                border: '1px solid #ccc',
                borderRadius: '4px',
                backgroundColor: selectedFormId === form.id ? '#d3d3d3' : '#fff',
                cursor: 'pointer',
                }}
                onClick={() => handleSelect(form.id)}
            >
                <strong>{form.name}</strong> -{' '}
                <Typography variant="body2" color="primary">
                    {form.eventID} - {form.date} - {form.description}
                </Typography>
            </li>
            ))}
        </ul>

        <div style={{ marginTop: '20px' }}>
            <button onClick={() => setIsAdding(true)} style={{ marginRight: '10px' }}>
            Add
            </button>
            <button
            onClick={handleEdit}
            style={{ marginRight: '10px' }}
            disabled={!selectedFormId}
            >
            Edit
            </button>
            <button onClick={handleDelete} disabled={!selectedFormId}>
            Delete
            </button>
        </div>

        {/* Add Form Modal */}
      {isAdding && (
        <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: '#fff', padding: '20px', border: '1px solid #ccc', borderRadius: '4px', zIndex: 1000 }}>
          <h2>Add New Event</h2>
          <form onSubmit={handleAddSubmit}>
            <div style={{ marginBottom: '10px' }}>
              <label>
                URL:
                <input
                  type="text"
                  value={newFormData.event_url}
                  onChange={(e) => setNewFormData({ ...newFormData, event_url: e.target.value })}
                  required
                  style={{ marginLeft: '10px' }}
                />
              </label>
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label>
                Name:
                <input
                  type="text"
                  value={newFormData.name}
                  onChange={(e) => setNewFormData({ ...newFormData, name: e.target.value })}
                  required
                  style={{ marginLeft: '10px' }}
                />
              </label>
            </div>
            <div style={{ marginBottom: '10px' }}>
            <label>
                    Date:
                    <input
                    type="text"
                    value={newFormData.date}
                    onChange={(e) =>
                        setNewFormData({ ...newFormData, date: e.target.value })
                    }
                    required
                    style={{ marginLeft: '10px' }}
                    />
                </label>
                </div>
                <div style={{ marginBottom: '10px' }}>
                <label>
                    Description:
                    <input
                    type="text"
                    value={newFormData.description}
                    onChange={(e) =>
                        setNewFormData({ ...newFormData, description: e.target.value })
                    }
                    required
                    style={{ marginLeft: '10px' }}
                    />
                </label>
                </div>
            <button type="submit" style={{ marginRight: '10px' }}>
              Save
            </button>
            <button onClick={() => setIsAdding(false)}>Cancel</button>
          </form>
        </div>
      )}


        {/* Edit Form Modal */}
        {isEditing && (
            <div
            style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: '#fff',
                padding: '20px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                zIndex: 1000,
            }}
            >
            <h2>Edit Form</h2>
            <form onSubmit={handleEditSubmit}>
            <div style={{ marginBottom: '10px' }}>
                <label>
                    URL:
                    <input
                    type="url"
                    value={editFormData.event_url}
                    onChange={(e) =>
                        setEditFormData({ ...editFormData, event_url: e.target.value })
                    }
                    required
                    style={{ marginLeft: '10px' }}
                    />
                </label>
                </div>
                <div style={{ marginBottom: '10px' }}>
                <label>
                    Name:
                    <input
                    type="text"
                    value={editFormData.name}
                    onChange={(e) =>
                        setEditFormData({ ...editFormData, name: e.target.value })
                    }
                    required
                    style={{ marginLeft: '10px' }}
                    />
                </label>
                </div>
                <div style={{ marginBottom: '10px' }}>
                <label>
                    Date:
                    <input
                    type="text"
                    value={editFormData.date}
                    onChange={(e) =>
                        setEditFormData({ ...editFormData, date: e.target.value })
                    }
                    required
                    style={{ marginLeft: '10px' }}
                    />
                </label>
                </div>
                <div style={{ marginBottom: '10px' }}>
                <label>
                    Description:
                    <input
                    type="text"
                    value={editFormData.description}
                    onChange={(e) =>
                        setEditFormData({ ...editFormData, description: e.target.value })
                    }
                    required
                    style={{ marginLeft: '10px' }}
                    />
                </label>
                </div>
                <button type="submit" style={{ marginRight: '10px' }}>
                Save
                </button>
                <button onClick={() => setIsEditing(false)}>Cancel</button>
            </form>
            </div>
        )}

        {/* Modal Background */}
        {isEditing && (
            <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 999,
            }}
            onClick={() => setIsEditing(false)}
            ></div>
        )}
        </div>
    );
}

export default EventsList;
